import { Board, CalendarBase, List } from '@doist/icons/brand';
import { Box, Text } from '@doist/marketist';
import { IconCard, type IconCardProps } from 'components/icon-card/icon-card';
import { SetupCard } from 'components/templates/setup-card/setup-card';
import { useTranslation } from 'next-i18next';
import css from './template-icon-card.module.css';
import type { TemplatePreview } from 'services/templates/types';
export type TemplateIconCardProps = {
  template: TemplatePreview;
  variant?: IconCardProps['variant'];
  forceSetupNarrowStyle?: boolean;
};
export function TemplateIconCard({
  template,
  variant,
  forceSetupNarrowStyle
}: TemplateIconCardProps) {
  const {
    t
  } = useTranslation('templates');
  if (template.template_type === 'setup') {
    return <SetupCard template={template} forceNarrowStyle={forceSetupNarrowStyle} />;
  }
  return <IconCard key={template.id} title={template.name} description={template.short_description} link={{
    href: `/templates/${template.id}`
  }} image={{
    src: `${template.thumbnail_image}?w=${variant === 'lg' ? 220 : 256}`,
    alt: ''
  }} tintColor={template.background_color} variant={variant} accessoryView={<Box className={css.accessoryView}>
                    <Box>
                        {template.view_type === 'list' ? <List /> : template.view_type === 'calendar' ? <CalendarBase /> : <Board />}
                    </Box>
                    <Text size="body-xs">{t(template.view_type?.toLowerCase() ?? 'list')}</Text>
                </Box>} data-sentry-element="IconCard" data-sentry-component="TemplateIconCard" data-sentry-source-file="template-icon-card.tsx" />;
}